import { Input } from '../../../../ui/input';
import type { BaseFieldProps, EmailFieldSchema, TextFieldSchema } from '../../../types';

export function TextFieldInput({
  field,
  value,
  onChange,
  error,
}: BaseFieldProps<TextFieldSchema | EmailFieldSchema, string | null | undefined>) {
  return (
    <Input
      id={field.id}
      type={field.type === 'email' ? 'email' : 'text'}
      placeholder={field.placeholder}
      value={value || ''}
      onChange={(e) => onChange?.(e.target.value)}
      aria-invalid={!!error}
    />
  );
}

export function TextFieldView({
  field,
  value,
  viewPlaceholder,
}: BaseFieldProps<TextFieldSchema | EmailFieldSchema, string | null | undefined>) {
  if (value === undefined || value === null || value === '') {
    return <span className="text-muted-foreground text-sm">{viewPlaceholder || '- -'}</span>;
  }

  let displayValue = value;
  // Handle potential future type mappings if needed
  if (field.type === ('date' as string)) {
    displayValue = new Date(value).toLocaleDateString();
  }

  return <span className="text-sm font-medium">{displayValue}</span>;
}
